var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end"},[_c('div',[_vm._v(" 活动已暂停,敬请期待开启时间呦！ ")])])}]

export { render, staticRenderFns }